<template>
  <div class="cardBody1">
    <el-row>
      <el-col :span="6">
        <div class="imagenContenedor">
          <img v-if="existePath" class="imagenDefault" :src="producto.PathImagen" @error="imageLoadError">
          <img v-else class="imagenDefault"  srcset="../../images/logo.png" >

        </div>
      </el-col>
      <el-col class="infoProducto" :span="18">
        <el-row>
          <el-col :span="20">
            <div class="label tituloProducto">{{ producto.Nombre }}</div>
          </el-col>
          <el-col :span="2">
            <div class="iconContainer" @click="detalleProducto">
              <el-tooltip class="item" effect="dark" :content="$t('PRODUCTO_detalle')" placement="left-start">
                <i class="el-icon-tickets"></i>
              </el-tooltip>
            </div>
          </el-col>
          <el-col :span="2">
            <div class="iconContainer" @click="agregarProducto">
              <el-tooltip class="item" effect="dark" :content="$t('PRODUCTO_agregar')" placement="left-start">
                <i class="el-icon-document-add" v-bind:class="{ intermitente: Cantidad>0 }"></i>
              </el-tooltip>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">

            <div class="label">{{producto.Descripcion}}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <input
              class="label"
              type="text"
              size="small"
              :placeholder="$t('PRODUCTO_nota_tecnica')"
              clearable
              v-model="productoSeleccionado.NotaTecnica"
            />
          </el-col>
          <el-col :span="6">
            <div class="label precio">{{$t('PEDIDO_iva')}} {{producto.IVA}}%</div>
          </el-col>
        </el-row>

        <!-- Seccion Mano de Obra -->
      <el-row v-if="pantallaOrigen == 'Presupuesto'">
          <el-col :span="16">
            <span>{{$t('PRESUPUESTO_mano_obra')}}</span>
          </el-col>
          <el-col :span="6">
            <div class="label manoObra">{{decimalToString(producto.ManoObra)}}</div>
          </el-col>
          <el-col :span="2">
            <el-checkbox v-model="manoObraChecked" style="margin-left: 6px; margin-top: 1px"></el-checkbox>
          </el-col>
        </el-row>


        <el-row>
          <el-col :span="10" >
            <!-- <el-input-number
              class="selectCantidadProducto"
                v-model="Cantidad"
                :min="0.0"
                size="mini"
                :precision="producto.AdmiteDecimales=='N'?0:1" :step="producto.AdmiteDecimales=='N'?1 : 0.1"
              ></el-input-number> -->
             <InputNumber
                class="selectCantidadProducto"
                :Cantidad="Cantidad"
                :AdmiteDecimales="producto.AdmiteDecimales"
                :Minimo="producto.AdmiteDecimales=='N'?'0': '0.0'"
                :Disabled="false"
                v-model="Cantidad"
                @cambio="changeCantidad" />
            </el-col>
          <el-col class="unidadMedida" :span="3">
            <div >{{producto.UnidadMedida}}</div>
          </el-col>
          <el-col v-if="pantallaOrigen == 'PedidoADistribuidor' || pantallaOrigen == 'PedidoSubagente'" :span="11">

          </el-col>
          <el-col v-else :span="11">
            <div class="label precio">{{ decimalToString(producto.Precio) }}</div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { decimalToString } from "../Helpers/commonFunctions";
import InputNumber from "../InputNumber/InputNumber";

export default {
  name: "ProductoCard",
  props: {
    producto: Object,
    pantallaOrigen: String
  },
  components:{
    InputNumber
  },
  data() {
    return {

      defaultImage: "../../images/logo.png",
      existePath:true,
      // defaultImage: "./images/logo.png",
      
      productoSeleccionado: {
        Clave: this.producto.Clave,
        Nombre: this.producto.Nombre,
        Descripcion: this.producto.Descripcion,
        Cantidad:undefined,
        IVA: this.producto.IVA,
        Precio: this.producto.Precio,
        NotaTecnica: undefined,
        subtotal: 0,
        BonificacionPorcentaje: this.producto.BonificacionPorcentaje,
        BonificacionImporte: undefined,
        EstadoVenta: this.producto.EstadoVenta,
        Leyenda: this.producto.Leyenda,
        UnidadMedida: this.producto.UnidadMedida,
        AdmiteDecimales: this.producto.AdmiteDecimales,
        Moneda: this.producto.Moneda,
        ManoObra: this.producto.ManoObra,
        ManoObraChecked: true,
        Promocion: this.producto.Promocion
      },

      Cantidad:0.0,
      manoObraChecked: true
    };
  },
  computed: {

  },
  
  methods: {
    decimalToString: decimalToString,
   changeCantidad(valorNuevo,valorViejo){
     this.Cantidad = valorNuevo;
   },
   
  agregarProducto() {
      if (this.Cantidad != 0) {
 
        this.productoSeleccionado.Cantidad = this.Cantidad;
        this.productoSeleccionado.ManoObraChecked = this.manoObraChecked

        this.productoSeleccionadoTemporal = this.productoSeleccionado;

        this.$emit("agregarProducto", this.productoSeleccionadoTemporal);
        
        if(this.pantallaOrigen == "Presupuesto"){
          this.productoSeleccionado = {
            Clave: this.producto.Clave,
            Nombre: this.producto.Nombre,
            Descripcion: this.producto.Descripcion,
            Cantidad: 0.0,
            IVA: this.producto.IVA,
            Precio: this.producto.Precio,
            NotaTecnica: undefined,
            subtotal: 0,
            BonificacionPorcentaje: 0,
            BonificacionImporte: 0,
            EstadoVenta: this.producto.EstadoVenta,
            Leyenda: this.producto.Leyenda,
            UnidadMedida: this.producto.UnidadMedida,
            AdmiteDecimales: this.producto.AdmiteDecimales,
            Moneda: this.producto.Moneda,
            ManoObra: this.producto.ManoObra,
            Promocion: this.producto.Promocion
          };
        }else{
            this.productoSeleccionado = {
            Clave: this.producto.Clave,
            Nombre: this.producto.Nombre,
            Descripcion: this.producto.Descripcion,
            Cantidad: 0.0,
            IVA: this.producto.IVA,
            Precio: this.producto.Precio,
            NotaTecnica: undefined,
            subtotal: 0,
            BonificacionPorcentaje: 0,
            BonificacionImporte: 0,
            EstadoVenta: this.producto.EstadoVenta,
            Leyenda: this.producto.Leyenda,
            UnidadMedida: this.producto.UnidadMedida,
            AdmiteDecimales: this.producto.AdmiteDecimales,
            Moneda: this.producto.Moneda,
            Promocion: this.producto.Promocion
          };
        }


        this.Cantidad = 0;
      }
      else{
        this.$alert(this.$t('PRODUCTO_agregar_producto_cantidad_cero'),this.$t('PRODUCTO_agregar_producto_error'))
      }
    },
    detalleProducto() {
      this.$emit("verDetalleProducto", this.producto);
    },
    imageLoadError(){
      this.existePath = false;
    }
  },
  created(){
    
  }
};
</script>

<style scoped>
.tituloProducto {
  color: var(--main-color);
}

.imagenContenedor {
  background-color: #ffffff;
  width: 100%;
  /* height: 80%; */
  max-height: 120px;
  margin-right: 10px;
  padding: 5px;
}
.label.precio {
  text-align: right;
}
.label.manoObra {
  text-align: right;
}
.unidadMedida {
  padding-top:5px; 
}

.imagenDefault {
  max-width: 6em;
    height: auto;
  max-height: 120px;
}

.content {
  padding: 17px;
  padding-bottom: 0;
  max-width: 400px;
}
.label {
  text-align: left;
  margin-bottom: 4px;
  font-size: 14px;
}
.el-card {
  height: 100%;
  width: 100% !important;
}
.cardBody1 {
  width: 100%;
  height: 170px;
  padding: 10px 5px;
  margin-right: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.number {
  text-align: center;
  width: 25px;
  border: 1px solid var(--main-color);
}
.boton {
  cursor: pointer;
  width: 30px;
  border: 1px solid var(--main-color);
  background-color: var(--main-color);
  border-radius: 1px;
  text-align: center;
}
.infoProducto .el-row {
  margin-left: 15px;
}

.iconoProd {
  color: #ffffff;
  font-weight: bold;
}
.el-row {
  margin-bottom: 5px;
}
.preciou:before {
  content: "Precio unitario:";
}
input {
  border: 0;
  outline: 0;
  width: 100%;
  background: transparent;
  border-bottom: 1px solid #dcdfe6;
  color: rgba(0, 0, 0, 0.849);
}
.iconContainer {
  cursor: pointer;
}

@media (max-width: 600px) {
  .imagenDefault{
    max-width: 5em;
  }
  .preciou:before {
    content: "";
  }
}

</style>

<style>

@media (max-width: 400px){
  .el-divider__text.is-left{
    transform: translateY(-60%);
  }
}

.selectCantidadProducto{
  width: 7em;
}

.el-input-number__increase,
.el-input-number__decrease {
  background: var(--main-color);
  color: white;
}
@media (max-width: 600px) {
  .selectCantidadProducto{
    width: 6em;
  }
}

.intermitente{  
  padding: 1px 1px;
  box-shadow: 0px 0px 1px;
  animation: infinite resplandorAnimation 2s;
  
}
@keyframes resplandorAnimation {
  0%,100%{
    box-shadow: 0px 0px 5px;
  }
  50%{
  box-shadow: 0px 0px 0px;
  
  }

}
</style>